<template>
  <div class="course-details">
    <el-main>
      <div class="course_header">
        <div class="course_img" v-if="courseRes.main_image">
          <!-- <el-image
            :src="$imgUrl + courseRes.main_image"
            fit="cover"
          ></el-image> -->
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          ></video-player>
        </div>
        <div class="course_list">
          <h3>課程列表({{ courseRes.tshCourseKpointList.length }})</h3>
          <ul>
            <li
              v-for="(item, index) in courseRes.tshCourseKpointList"
              :key="item.kpiont_id"
              @click="fnToCourseDetails(item.kpiont_id , index)"
              class="little_hand"
            >
              <img v-if="active==index" src="../assets/imgs/play.svg" />
              <span :class="{'active':active==index}">【{{ index + 1 }}】{{ item.name }}</span>
              <!-- <i class="el-icon-video-play"></i> -->
            </li>
          </ul>
        </div>
      </div>

      <div class="course_info">
        <h3>
          {{ courseRes.course_name }}
          <time>
            发布于{{ $dayjs(courseRes.create_time).format("YYYY-MM-DD") }}
          </time>
        </h3>
        <p v-html="courseRes.description"></p>
        <div
          class="coursePrice"
          v-if="freeArr.length == courseRes.tshCourseKpointList.length"
        >
          免费
        </div>
        <div class="coursePrice" v-else>
          价格 <span class="finalPrice">￥{{ current_price.toFixed(2) }}</span>
        </div>
        <div
          class="btns"
          v-if="freeArr.length == courseRes.tshCourseKpointList.length"
        >
          <!-- <el-button
            @click="
              fnToCourseDetails(courseRes.tshCourseKpointList[0].kpiont_id)
            "
            >立即播放</el-button
          > -->
        </div>
        <div class="btns" v-else>
          <el-button class="buy_btn" @click="getCodeUrl">立即購買</el-button>
          <el-button
            class="try_btn"
            @click="
              fnToCourseDetails(courseRes.tshCourseKpointList[0].kpiont_id)
            "
            >免費試看<i class="el-icon-video-play"></i
          ></el-button>
        </div>
      </div>
      <el-dialog
        :visible.sync="isShowQcode"
        title="打開微信掃一掃付款"
        width="450px"
        center
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <i class="el-icon-close" @click="isShowQcode = false"></i>
        <img :src="payCode" width="200px" height="200px" />
      </el-dialog>
    </el-main>
  </div>
</template>

<script>
import { mapState } from "vuex";
var timer;
export default {
  data() {
    return {
      isShowQcode: false,
      courseRes: {},
      active:0,
      // feeList:[
      //   {
      //     name:'',
      //     price:0,
      //     description:'需要購買才能解鎖更多課程',
      //   }
      // ],
      current_price: 0,
      freeArr: [],
      code_url: "",
      isPaying: false, //是否正在支付
      payStartTime: "",
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", //url地址
          },
        ],
        poster: "", //你的封面地址
        width: "800px", //播放器宽度
        height: "490px",
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },
  computed: {
    ...mapState(["user_id", "validToken"]),
    // qrCodeImg(){
    //   return 'https://api2.ts960.com/jehc-web-app/api/v2/QRcode/createQRcode?url=https://api2.ts960.com/wechatxh/html/association-file-details.html?cunpan_id=' + this.$route.params.id
    // },
    payCode() {
      return `https://api2.ts960.com/jehc-web-app/api/v2/QRcode/createQRcode?url=${this.code_url}`;
    },
  },
  methods: {
    async getCourseDetails() {
      const { data: res } = await this.$http.get(
        `/api/v2/course/${this.$route.params.id}?user_id=${this.user_id}`
      );
      console.log(res);
      this.courseRes = res.data;
      this.current_price = res.data.current_price;
      let newdate = new Date();
      let diff = (newdate - this.payStartTime) / 1000 / 60;
      this.fnToCourseDetails(this.courseRes.tshCourseKpointList[0].kpiont_id,0);
      if (res.code == 51000) {
        if (diff > 5 && this.isPaying) {
          this.$message.error("支付失敗");
          clearInterval(timer);
          this.isShowQcode = false;
          this.isShowFeeList = false;
        }
      } else {
        if (this.isPaying) {
          this.$message.success("支付成功");
          clearInterval(timer);
        }
        this.isShowQcode = false;
      }

      this.freeArr = res.data.tshCourseKpointList.filter((item) => {
        if (item.is_free == 1) {
          return item;
        }
      });
    },
    async getCodeUrl() {
      if (!this.validToken) {
        this.$store.state.isDialogVisible = true;
      } else {
        this.isShowQcode = true;
        const { data: res } = await this.$http.post(
          `/api/v2/order/resourcesPayByH5/${this.$route.params.id}/11/${
            this.user_id
          }/${
            this.current_price
          }/${"Tobfusion"}?ipAddress=${localStorage.getItem("Ip")}`
        );
        console.log(res);
        this.code_url = res.data.code_url;

        this.isPaying = true;
        this.payStartTime = new Date();
        timer = setInterval(() => {
          this.getArticleDetails();
        }, 5000);
      }
    },
    async fnToCourseDetails(kpiont_id,index) {
      const { data: res } = await this.$http.get(
        `/api/v2/course/kpiont/${kpiont_id}?user_id=${this.user_id}`
      );
      // console.log(res);
      if (res.code == 51000) {
        this.getCodeUrl();
      } else if (res.data.video_url) {
        this.playerOptions.sources[0].src = res.data.video_url;
        this.active=index
        // this.$router.push({
        //   path: `/course_details/${this.$route.params.id}/${kpiont_id}`,
        // });
      }
    },
  },
  created() {
    this.getCourseDetails();
  },
};
</script>

<style lang="less" scoped>
.course-details {
  background: #f2f2f2;
  padding: 50px 0;
}
.el-main {
  width: 1200px;
  margin: 0 auto;
}
.course_header {
  margin: auto;
  display: flex;
  justify-content: center;
  .course_img {
    flex: 1;
    height: 490px;
    border-radius: 8px;
    overflow: hidden;
  }
  .course_list {
    background: #fff;
    width: 390px;
    margin-left: 10px;
    padding: 15px 20px 5px;
    border-radius: 8px;
    height: 490px;
    overflow-y: auto;
    box-sizing: border-box;
    h3 {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #222222;
      letter-spacing: 0;
      text-align: justify;
      font-weight: 400;
      line-height: 20px;
    }
    li {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #222222;
      font-weight: 400;
      border-bottom: 1px solid #eeeeee;
      padding: 10px 0;
      display: flex;
      align-content: center;
      overflow: hidden;
      img {
        width: 20px;
        height: 20px;
        filter: drop-shadow(#20317f 80px 0);
        transform: translateX(-80px);
      }
      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      .active{
        color: #20317F;
font-weight: 700;
      }
      i {
        font-size: 26px;
      }
    }
    li:last-child {
      border-bottom: none;
    }
  }
}

.course_info {
  background: #ffffff;
  border-radius: 8px;
  margin-top: 10px;
  padding: 20px;
  h3 {
    font-family: MicrosoftYaHei-Bold;
    font-size: 20px;
    color: #222222;
    letter-spacing: 0;
    line-height: 30px;
    font-weight: 700;
    display: flex;
    align-content: center;
  }
  p {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #999999;
    letter-spacing: 0;
    text-align: justify;
    font-weight: 400;
    margin: 5px 0 10px;
  }
  time {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #888888;
    letter-spacing: 0;
    font-weight: 400;
    margin-left: 15px;
  }
  .coursePrice {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #ff3a30;
    letter-spacing: 0;
    font-weight: 400;
    .finalPrice {
      margin-left: 10px;
      font-size: 30px;
      font-weight: 500;
      color: #f00;
    }
  }
  .btns {
    display: flex;
  }
  .el-button {
    margin-top: 35px;
    width: 176px;
    height: 56px;
    text-align: center;
    background: #47b379;
    border-radius: 4px;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    position: relative;
    margin-left: 16px;
    border: none;
    font-weight: normal;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .buy_btn {
    background: #dd8800;
  }
  .try_btn {
    color: #dd8800;
    background: #fff;
    i {
      margin-left: 5px;
      font-size: 20px;
    }
  }
}
/deep/.el-dialog {
  border-radius: 22px;
  margin-top: 30vh !important;
  .el-dialog__title {
    line-height: 60px;
    font-size: 20px;
    color: #303133;
    font-weight: bold;
  }
  i {
    position: absolute;
    right: 25px;
    top: 25px;
    font-size: 28px;
    font-weight: bold;
    cursor: pointer;
  }
  img {
    display: block;
    margin: auto;
  }
}
@media screen and (max-width: 768px) {
  .course_header {
    flex-direction: column;
  }
  .course_header .course_info h3 {
    font-size: 20px;
    margin-top: 20px;
  }
  .course_header .course_img {
    max-width: 100%;
    margin-right: 0;
  }
  .course_header .course_info p {
    width: auto;
  }
  .course_list {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
<style >
.video-player,
.vjs-custom-skin > .video-js {
  height: 100% !important;
}
</style>
